<div
  edsGrid
  [edsSpacing]="(isHandheld$ | async) === false ? 'xxxl' : 'xxl'"
  edsPadding
  [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
  [edsPaddingRight]="(isHandheld$ | async) ? 'sm' : 'none'"
>
  <section
    [edsSpacing]="(isHandheld$ | async) ? 'md' : 'lg'"
    edsPadding
    [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
  >
    <!-- breadcrumb area -->
    <eds-breadcrumbs
      [items]="showBreadcrumb ? breadcrumbItems : null"
      theme="basic"
      edsPadding
      edsPaddingLeft="sm"
    >
    </eds-breadcrumbs>
    <div class="container" edsPadding edsPaddingTop="lg">
      <!-- Order Success -->
      <p edsSpacing="xs" class="pre-title">
        {{ "literature.mail-page-title" | translate }}
      </p>
      <eds-title
        edsSpacing="xs"
        title="{{ 'literature.mail-title-mailing-address' | translate }}"
        size="h2"
        theme="basic"
        [level]="1"
        [isLight]="true"
      ></eds-title>
      <eds-title
        edsSpacing="none"
        title="{{
          'literature.mail-title-mailing-address-description' | translate
        }}"
        size="h6"
        theme="basic"
        [level]="3"
        [isLight]="true"
      ></eds-title>
    </div>
  </section>
  <div class="container">
    <div
      *ngIf="cartState?.length > 0"
      edsSubGrid="layout-3"
      edsSubGridGap="xxxl"
      edsSpacing="lg"
    >
      <ft-literature-your-cart-mail-form
        [cartState]="cartState"
        (mailFormValues)="setFormValues($event)"
        (yourCartPage)="yourCartPage()"
      >
      </ft-literature-your-cart-mail-form>
      <div>
        <div edsFlexbox justifyContent="space-between">
          <eds-title
            edsSpacing="sm"
            title="{{ 'literature.lit-cart-summary-title' | translate }}"
            size="h6"
            theme="basic"
          ></eds-title>
          <eds-link-item
            edsSpacing="md"
            title="{{ 'literature.lit-cart-summary-edit' | translate }}"
            [href]="myCartLink"
          ></eds-link-item>
        </div>
        <div edsSpacing="md">
          <eds-sidebar
            [closeButton]="true"
            [divider]="false"
            [hasPadding]="false"
          >
            <ng-container *ngIf="cartState?.length > 0">
              <div *ngFor="let item of cartState; let i = index">
                <a
                  edsPadding
                  edsPaddingAll="md"
                  [href]="getLiteratureDetailLink(item.docId)"
                  class="text-decoration-none sidebar__list-item text-black"
                  edsFlexbox
                  alignItems="flex-start"
                  justifyContent="space-between"
                >
                  <div edsPadding edsPaddingRight="sm">
                    <p>{{ item.fundName }}</p>
                    <p edsSpacing="none">Qty: {{ item.quantity }}</p>
                  </div>
                  <eds-icon
                    class="text-primary"
                    size="small"
                    type="carrot-right"
                    aria-hidden="true"
                  >
                  </eds-icon>
                </a>
                <eds-divider *ngIf="i < cartState.length - 1"></eds-divider>
              </div>
            </ng-container>
          </eds-sidebar>
        </div>
        <eds-sidebar
          [closeButton]="true"
          [divider]="false"
          [hasPadding]="false"
        >
          <div edsPadding edsPaddingAll="md">
            <p>{{ "literature.lit-cart-summary-need-help" | translate }}</p>
            <p edsSpacing="none">
              {{ "literature.lit-cart-summary-call" | translate }}
            </p>
          </div>
        </eds-sidebar>
      </div>
    </div>
  </div>
</div>
